import { Button, ExitBtn } from 'components/atoms';
import { RoundProfilePicture } from 'components/atoms/RoundProfilePicture/Picture';
import React, { FC, useState, useEffect, useLayoutEffect } from 'react';
import { getAssetPathAndSize, useDeviceClassification } from 'utils';
import styles from "./Contact.module.css";
import buttonStyles from "../../atoms/Button/Button.module.css";
import classNames from 'classnames';
import Modal from "react-modal";
import { ContactModalCard } from './components/ContactModalCard';
import he from "he";
import { ReactModalStyles } from 'components/constants';

export type TContactItems = {
    ContactJobPosition: string;
    Firstname: string;
    Surname: string;
    FullBio: string;
    Bio: string;
    ContactEmail: string;
    LinkedInProfile: any;
    TwitterProfile: any;
    ProfileLink: any;
    Photo: any;
    Fax: string;
    ContactPhone: string;
}

type TContactUsProps = {
    DisplaySideBar: boolean,
    ContactUsTitle?: string;
    ContactUsDescription?: string;
    ContactLinkPool: TContactItems[];
}

export const ContactUsSection: FC<TContactUsProps> = ({
    DisplaySideBar,
    ContactUsTitle,
    ContactUsDescription,
    ContactLinkPool
}) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [activeCard, setActiveCard] = useState<TContactItems | null>(null);

    useLayoutEffect(() => {
        document.querySelectorAll('.contact-us-subtext a').forEach((v) => {
            v.classList.add('button-2022');
        })
    }, []);

    useEffect(() => {
        if (activeCard) {
            setShowModal(true);
            document.getElementById("main-navigation")?.classList.remove("active");
            document.querySelector("body").classList.add("no-scroll");
        }

    }, [activeCard]);

    const handleClose = () => {
        setActiveCard(null);
        setShowModal(false);
        document.querySelector("body").classList.remove("no-scroll");
    };

    const { isDesktop } = useDeviceClassification();

    return (
        <section className={classNames(styles.contianer, 'animateonscroll')}>
            <div className={classNames(styles.contentWrapper, 'm-auto', `${!DisplaySideBar && isDesktop ? "col-8" : "col-12"}`)}>
                <div className={styles.headings}>
                    <h2>{he.decode(ContactUsTitle)}</h2>
                    <div className={classNames(styles.subtext, "contact-us-subtext")} dangerouslySetInnerHTML={{ __html: ContactUsDescription }} />

                    <div className={styles.contacts}>
                        {ContactLinkPool.map((v, i) =>
                            <div
                                key={v?.Firstname + v?.Surname + i}
                                className={classNames(styles.contactItem, { 'span-6': !DisplaySideBar })}>
                                <RoundProfilePicture
                                    width={'72px'}
                                    image={{ Src: getAssetPathAndSize(v?.Photo?.Src, 20), Alt: v?.Photo?.Alt }} />

                                <div className={styles.text}>
                                    <div>
                                        <span>{he.decode(v?.Firstname) + ' ' + he.decode(v?.Surname)}</span>
                                        <p>{he.decode(v?.ContactJobPosition)}</p>
                                    </div>

                                    <Button
                                        className={`contact-button-${v.Firstname + v.Surname}`}
                                        onClick={() => setActiveCard(v)}
                                        as="button"
                                        buttonStyle='chevron'>
                                        CONTACT ME
                                        <span className={classNames(buttonStyles.chevron, styles.chevron)}>
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            <Modal
                style={{...ReactModalStyles}}
                isOpen={showModal}
                className="Modal"
                onRequestClose={() => handleClose()}
                shouldCloseOnOverlayClick={true}
            >
                {activeCard && <div className={classNames(styles.modalContainer)}>
                    <ExitBtn
                        style={{ top: '20px', right: '20px' }}
                        handleIsOpenChange={() => handleClose()} />
                    <ContactModalCard activeCard={activeCard} />
                </div>}


            </Modal>
        </section>
    )
}